import { getListTransform, getDetailTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: true,
  buttonLoading: false,
  subscriptions: [],
  subscriptionsLoading: false,
  showConfirmation: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LIST_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.ITEM_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload.data) || INITIAL_STATE.detail,
        loading: false,
      };
    case types.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case 'PLANS_SUBSCRIPTIONS_FETCHED':
      return {
        ...state,
        subscriptions: action.payload,
        subscriptionsLoading: false,
      };
    case 'PLANS_SUBSCRIPTIONS_LOAD':
      return {
        ...state,
        subscriptionsLoading: action.payload,
      };
    case 'PLANS_SUBSCRIPTIONS_SHOW_CONFIRMATION':
      return {
        ...state,
        showConfirmation: action.payload,
      };
    default:
      return state;
  }
};
